/**
 * @class Oskari.userinterface.extension.DefaultTile
 *
 * Default Menu Tile implementation which assumes a locale
 * of kind
 * {
 *     "title" : "<title shown to user>",
 *     "description" : "<a longer localised description>"
 * }
 *
 */
Oskari.clazz.define('Oskari.userinterface.extension.DefaultTile',
/**
 * @method create called automatically on construction
 * @static
 *
 * Always extend this class, never use as is.
 */

function (instance, locale) {
  /**
   * @property locale localisation for this tile
   */
  this.locale = locale;

  /**
   * @property extension bundle instance
   */
  this.instance = instance;
  this.container = null;
  this.template = null;
}, {
  /**
   * @method getName
   * @return {String} tile implementation name
   */
  getName: function getName() {
    return 'Oskari.userinterface.extension.DefaultTile';
  },
  /**
   * @method setEl
   * called by host implementation to add DOM element where the
   * tile is to be rendered
   */
  setEl: function setEl(el, width, height) {
    this.container = jQuery(el);
  },
  /**
   * @method startPlugin
   * called by host implementation when the tile is to be started
   * f.ex to provide some kind of active visualisations.
   */
  startPlugin: function startPlugin() {
    var isContainer = !!(this.container && this.instance.mediator);
    var isBundleId = !!(isContainer && this.instance.mediator.bundleId);
    var isInstanceId = !!(isContainer && this.instance.mediator.instanceId);
    if (isInstanceId && !this.container.hasClass(this.instance.mediator.instanceId)) {
      this.container.addClass(this.instance.mediator.instanceId);
    }
    if (isBundleId && !this.container.hasClass(this.instance.mediator.bundleId)) {
      this.container.addClass(this.instance.mediator.bundleId);
    }
  },
  /**
   * @method stopPlugin
   * called by host when the tile is to be removed
   */
  stopPlugin: function stopPlugin() {
    if (this.container && this.container.empty) {
      this.container.empty();
    }
  },
  /**
   * @method getTitle
   * @return {String} called by host to get a localised title to be shown
   *
   */
  getTitle: function getTitle() {
    return this.locale.title;
  },
  /**
   * @method getDescription
   * @return {String} called by host to get a longer description for display
   */
  getDescription: function getDescription() {
    return this.locale.description;
  },
  /**
   * @method getOptions
   * @return {JSON} a placeholder for future implementations
   */
  getOptions: function getOptions() {},
  /**
   * @method setState
   * placeholder for future implementations
   */
  setState: function setState(state) {
    this.state = state;
  },
  /**
   * @method getState
   * @return {JSON} placeholder for future implementations
   */
  getState: function getState(state) {
    return this.state;
  },
  /**
   * Enables or disables the tile
   * @param {Boolean} blnEnabled true to enable.
   */
  setEnabled: function setEnabled(blnEnabled) {
    if (blnEnabled) {
      this.container.removeClass('disabled');
    } else {
      this.container.addClass('disabled');
    }
  },
  /**
   * Returns true if tile is enabled
   * @return {Boolean} true if enabled
   */
  isEnabled: function isEnabled() {
    return !this.container.hasClass('disabled');
  }
}, {
  'protocol': ['Oskari.userinterface.Tile']
});